import React from 'react';
import {SoopButtonCircle} from '@soop-ui/soop-ui';
import styles from './Note.module.scss';
import {goLogin, isLogin} from '@/utils/main';
import {isMobile} from 'react-device-detect';
import globalDomains from '@/utils/global-domains';
import {useParams} from 'react-router-dom';
import throwToast from '@/utils/ui/toast';
import {useStationData} from '@/stores/channel/station';

const BtnNote = () => {
  const isLoggedIn = isLogin();
  const {station} = useStationData();
  const {userId: streamerId} = station.detail || {};

  const handleNoteClick = async (e: React.MouseEvent) => {
    if (isLoggedIn) {
      if (isMobile) {
        window.open(`${globalDomains.M_AFREECATV}/#/note/write2/${streamerId}`);
      } else {
        let oWindow = window.open(
          `${globalDomains.NOTE_AFREECATV}/app/index.php?page=write&id_list=${streamerId}`,
          'noteWriteWindow',
          'left=10,top=10,width=400,height=440,marginwidth=0,marginheight=0,resizable=0,scrollbars=no',
        );

        if (!oWindow) {
          throwToast('차단된 팝업을 허용해주세요.');
        } else {
          oWindow.focus();
        }
      }
    } else {
      goLogin();
    }
    e.preventDefault();
  };
  return (
    <SoopButtonCircle
      className={styles.btnNote}
      iconName='icoNote'
      onClick={handleNoteClick}
      size={24}
      variant='linePrimary'
    />
  );
};

export default BtnNote;
